const CATEGORY_COLORS: Record<string, string> = {
  blue: '#3b82f6',
  purple: '#8b5cf6',
  green: '#22c55e',
  red: '#ef4444',
  amber: '#f59e0b',
  orange: '#f97316',
  pink: '#ec4899',
  cyan: '#06b6d4',
  lime: '#84cc16',
  violet: '#7c3aed',
}

export function getCategoryColor(color: string): string {
  return CATEGORY_COLORS[color] ?? CATEGORY_COLORS.blue
}
